import React from "react";
import { IMAGES } from "../../utils/imageAssets";
import "./AppInstallModal.css";

interface AppInstallModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const AppInstallModal: React.FC<AppInstallModalProps> = ({
  isOpen,
  onClose,
}) => {
  if (!isOpen) return null;

  return (
    <div className="app-install-modal active">
      <div className="app-install-modal-content">
        <button className="app-install-modal-close" onClick={onClose}>
          &times;
        </button>
        <h2 className="app-install-modal-title">
          지금 바로 <span className="highlight">앱 설치</span>를 시작하세요!
        </h2>
        <div className="app-install-modal-body">
          <div className="app-install-modal-left">
            <div className="app-install-modal-sub">스토어 다운로드</div>
            <a
              href="https://apps.apple.com/kr/app/%EB%A0%88%EB%94%94%EC%8A%A4%ED%94%BD-readyspeak-%EC%98%81%EC%96%B4%ED%9A%8C%ED%99%94-%EC%8A%A4%ED%94%BC%ED%82%B9-%EB%B0%9C%EC%9D%8C/id6467833331"
              className="store-btn appstore-btn"
              target="_blank"
              rel="noopener"
            >
              <img
                src={IMAGES.APPS.APP_STORE}
                alt="App Store"
                style={{ height: 45 }}
              />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=kr.co.machoo.machooeng&hl=ko"
              className="store-btn googleplay-btn"
              target="_blank"
              rel="noopener"
            >
              <img
                src={IMAGES.APPS.GOOGLE_PLAY}
                alt="Google Play"
                style={{ height: 48 }}
              />
            </a>
          </div>
          <div className="app-install-modal-divider"></div>
          <div className="app-install-modal-right">
            <div className="app-install-modal-sub">QR코드 다운로드</div>
            <img
              src={IMAGES.APPS.QR_CODE}
              alt="QR코드"
              className="app-install-modal-qr"
            />
            <div className="app-install-modal-qr-desc">
              핸드폰 카메라로
              <br />
              코드를 스캔하세요
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AppInstallModal;
